import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Theme } from '@mui/material/styles'

import {
  setPrefersDarkMode,
  setTheme,
  setMessage, setFeedback,
} from './settings.actions'

import { ApiError } from '../root.reducer'
import produce from 'immer'
import { getAppTheme } from '../../shared/config/getAppTheme'

export interface SettingsState {
  fetching: boolean
  prefersDarkMode: boolean
  theme: Theme
  message?: any
  feedback?: any
  error: ApiError
}

const INITIAL_SETTINGS_STATE: SettingsState = {
  fetching: false,
  prefersDarkMode: localStorage.getItem('darkMode') === 'true',
  theme: getAppTheme(),
  error: {},
}

export const settingsStateReducer = reducerWithInitialState(INITIAL_SETTINGS_STATE)
  .case(setPrefersDarkMode, (state: SettingsState, prefersDarkMode: boolean) => {
    return ({ ...state, prefersDarkMode })
  })
  .case(setTheme, (state: SettingsState, theme: Theme) => {
    return ({ ...state, theme })
  })
  .case(setMessage, (state, message) => {
    return produce(state, (draft) => {
      draft.message = message
    })
  })
  .case(setFeedback, (state, feedback) => {
    return ({ ...state, feedback })
  })
